/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

// project imports
// import toast from 'shared/toast';

//style imports
import './ItemsEdit.scss';

/**

@Author Karthik

@param

@return Images reorder html

**/


const SortableItem = SortableElement(({ image, removeItem, editItem, toggleVideoModal, mediaIndex }) => {
	return (
		<div className="image-container">
			{
				image.type === 'image' ?
					<img
						style={{   border: '0.02rem solid' }}
						alt='100%x190'
						src={image.setDummyImage ? process.env.PUBLIC_URL + "/static/images/dummy_image.png" : image.src}
						key={image.src}
						data-holder-rendered='true'
					/> :
					<div className="d-flex flex-row justify-content-center align-items-center border bg-dark"
						style={{ position: 'relative', width: 'max-content' }}>
						<i className="far fa-play-circle fa-3x text-white clickable" style={{ position: 'absolute', zIndex: '1' }}
							onClick={() => toggleVideoModal(mediaIndex)}
						></i>
						<video key={image.src} onContextMenu={event => event.preventDefault()} style={{ height:'136px',  opacity: 0.7 }}>
							<source src={image.src} />
							Your browser does not support video element.
						</video>
					</div>
			}
			{
				image.type === 'image' ?
					<img className="imageEdit" src={`${process.env.PUBLIC_URL}/static/icons/sidebar/image_edit.svg`} alt="edit" style={image.currentBid && image.currentBid!==0 ? {right:'8px'} :{right:'27px'}}onClick={() => { editItem(image) }} /> :
					null
			}
		{ 
		image.currentBid && image.currentBid!==0 ? null :	
		<img className="imageDelete" src={`${process.env.PUBLIC_URL}/static/icons/sidebar/image_delete.svg`} alt="delete"  style={{ right: "5px" }} onClick={(event) => { image.currentBid && image.currentBid!==0 ? event.preventDefault() : removeItem(image) }} /> 
		
		}
		</div>
	)
});

const SortableList = SortableContainer(({ items, removeItem, editItem, toggleVideoModal }) => {
	return (
		<div className="d-flex" style={{ flexWrap: "wrap" }}>
			{items.map((value, index) => (
				<SortableItem key={`media-${index}`} index={index} mediaIndex={index} image={value} removeItem={removeItem}
					editItem={editItem} toggleVideoModal={toggleVideoModal} />
			))}
		</div>
	);
});

class ReorderImages extends Component {
	imageIds = [];
	constructor(props) {
		super(props);
		const { images } = props;
		this.state = {
			images: images,
			dragId: '',
			renderImg: [],
			imageIds: []
		};
	}

	deleteImage = (event) => {		 
			this.props.deleteImage(event); 	
	}
	editImage = (event) => {
		this.props.editImage(event);
	}

	toggleVideoModal = (index) => {
		this.props.toggleVideoModal(index);
	}

    //Handle Shuffle across the Images
    Shuffle(array, fromIndex, toIndex) {
		const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
	
		if (startIndex >= 0 && startIndex < array.length) {
			const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
	
			const [item] = array.splice(fromIndex, 1);
			array.splice(endIndex, 0, item);
		}
		this.setState({
			images : array
		})
	}

	onSortEnd = ({ oldIndex, newIndex }) => {
		let { images } = this.state
			if (this.state.images[oldIndex]['type'] === 'video' && newIndex == 0) {
				// toast.error('Video should not be display image');
				this.props.callback({ 'errorMessage': 'Video should not be display image' });
			} 
			else if (oldIndex === 0 && this.state.images[1]['type'] === 'video') {
				this.props.callback({ 'errorMessage': 'Video should not be display image' });
			}			
			else {
				this.imageIds.push(this.state.images[oldIndex]['id'], this.state.images[newIndex]['id']);
				this.imageIds = [...new Set(this.imageIds)];
				this.Shuffle(images,oldIndex,newIndex)
				// const temp = this.state.images[oldIndex];
				// let images = this.state.images
				// images[oldIndex] = this.state.images[newIndex];
				// images[oldIndex]['isdisplayimage'] = 0;				
				// images[newIndex] = temp;
				// images[newIndex]['isdisplayimage'] = 1;
				// this.setState({
				// 	images
				// })

				// this.setState(({images}) => ({
				// 	images: this.Shuffle(images, oldIndex, newIndex),
				// }));

				this.props.callback({ 'images': this.state.images, 'imageIds': this.imageIds });
			}
	};
	render() {
		return (
			<SortableList axis="xy" items={this.state.images} removeItem={this.deleteImage} editItem={this.editImage}
				onSortEnd={this.onSortEnd} distance={1} toggleVideoModal={this.toggleVideoModal} />
		);
	}
}

export default ReorderImages;
